export const IesApplicationImStatus = {
  1: { displayValue: 'Awaiting Assignment to Worker', help: 'In queue' },
  2: { displayValue: 'In Progress', help: 'Assessment started' },
  3: { displayValue: 'Closed', help: 'With decision' },
};

// Object.fromEntries is not available at this time
const objectFromValues = (values: [string, number][]): { [key: string]: number } => {
  const o = {};
  values.forEach((v) => (o[v[0]] = v[1]));
  return o;
};

export const IesApplicationImStatusByName: { [key: string]: number } = objectFromValues(
  Object.entries(IesApplicationImStatus).map((e) => [e[1].displayValue.replace(/\s/g, ''), +e[0]])
);
